<div class="flex align-items-start gap-3 align-self-stretch">
  <div class="contact-card gray">
    <div class="flex p-2 flex-column align-items-start gap-2 flex-1-0-0">
      <div class="flex align-items-start gap-2 align-self-stretch">
        <div class="flex flex-column align-items-start gap-1 flex-1-0-0">
          <div class="contact-text title">
            {{ organisationData?.name }}
          </div>
          <div class="contact-text">
            {{ organisationData?.streetNr }}
          </div>
          <div class="contact-text">
            {{ organisationData?.postalCode }}&nbsp;{{ organisationData?.city }}
          </div>
        </div>
        @if (organisationData?.customerStatus) {
          <p-tag [value]="organisationData.customerStatus | customerStatusTag : 'VALUE'"
                 [severity]="organisationData.customerStatus | customerStatusTag : 'SEVERITY'"
                 [icon]="organisationData.customerStatus | customerStatusTag : 'ICON'"/>
        }
      </div>
      <div class="contact-text p-t-1 p-b-1 align-self-stretch">
        <span class="title">{{ i18n.i18nLng()['MERCHANTIDSHORT'] }}:&nbsp;</span>
        <span>{{ organisationData?.displayCustomerNumber }}</span>
      </div>
      <div class="contact-text p-t-1 p-b-1 align-self-stretch">
        <span class="title">{{ i18n.i18nLng()['CUSTOMERGROUP'] }}:&nbsp;</span>
        <span>{{ i18n.i18nLng()['CUSTOMER_GROUP_' + (organisationData?.customerGroup ? organisationData?.customerGroup : CustomerGroup.DIRECT)] }}</span>
      </div>
      <!--
      <div class="contact-text align-self-stretch">
        <span class="title">{{ i18n.i18nLng()['EMAIL'] }}:&nbsp;</span><span>{{ organisationData?.email }}</span>
      </div>
      <div class="contact-text p-b-1 align-self-stretch">
        <span class="title">{{ i18n.i18nLng()['PHONE'] }}:&nbsp;</span><span>{{ organisationData?.phone }}</span>
      </div>
      -->
      @if (organisationData?.dataCenterId) {
        <div class="contact-text align-self-stretch">
          <div class="title">{{ i18n.i18nLng()['DATACENTER'] }}:</div>
          <div>{{ organisationData?.dataCenter }}</div>
        </div>
      }
    </div>
  </div>
</div>
<div class="flex flex-column align-self-stretch mt-2">
  <p-table [value]="organisationPaymentTypes"
           [scrollable]="true"
           scrollHeight="20rem">
    <ng-template pTemplate="header">
      <tr>
        <th class="large-icon-cell force-size"></th>
        <th>{{ i18n?.i18nLng()['PAYMENTTYPES'] }}</th>
        <th>{{ i18n?.i18nLng()['STATUS'] }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-pt>
      <tr>
        <td class="large-icon-cell force-size">
          @if (pt.customIcon) {
            <sps-custom-icon [name]="pt.icon" [alt]="i18n.i18nLng()[pt.paymentMethod]" [size]="21"></sps-custom-icon>
          } @else {
            <i [ngClass]="pt.paymentMethod | keyToIcon"></i>
          }
        </td>
        <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis purpose-cell">
          {{ pt.title }}
        </td>
        <td>
          <sps-payment-status-tag [status]="pt.status"></sps-payment-status-tag>
        </td>
      </tr>
    </ng-template>

  </p-table>
</div>
